import { connect } from 'react-redux';
import DroppedCallModal from 'components/DroppedCallModal/DroppedCallModal';
import { callActions, callSelectors, networkSelectors, userProfileSelectors } from '@lifesize/nucleus';
import { closeFullScreenModal } from 'actions/FullScreenModal';
import { navigateToTrialPage } from 'actions/Application';
import { cancelJoinCall, resetGuestCall } from 'actions/JoinModal';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  return {
    isGuest: userProfileSelectors.selectIsGuest(state),
    callDialString: activeCall.dialString,
    isWebConferencing: _get(activeCall, 'isWebConferencing'),
    isVideoEnabled: _get(state, 'app.joinModal.isVideoEnabled'),
    isAudioEnabled: _get(state, 'app.joinModal.isAudioEnabled'),
    isJoinFlowCall: _get(state, 'app.joinModal.isJoinFlowCall'),
    defaultAudioSetting: _get(state, 'app.settingsModal.defaultAudioSetting'),
    hasVideo: _get(state, 'app.call.hasVideo'),
    isOnline: networkSelectors.isOnline(state)
  };
};

const mapDispatchToProps = dispatch => ({
  redialCall: (dialString, isWebConferencing, isJoinFlowCall, media) => {
    dispatch(resetGuestCall());
    if (isWebConferencing) {
      dispatch(closeFullScreenModal());
      dispatch(callActions.webConferenceCall(dialString, media));
    } else {
      dispatch(callActions.call(dialString, media));
    }
  },
  clearCall: (isGuest) => {
    dispatch(callActions.clearCall());
    dispatch(closeFullScreenModal());
    dispatch(cancelJoinCall());
    if (isGuest) {
      dispatch(navigateToTrialPage());
    }
  }
});

const mergeProps = (stateProps, dispatchProps, ownProps) => (
  Object.assign({}, ownProps, stateProps, dispatchProps,
    {
      redialCall: () => {
        let media = { video: stateProps.hasVideo, audio: stateProps.defaultAudioSetting };
        if (stateProps.isJoinFlowCall) {
          media = { video: stateProps.isVideoEnabled, audio: stateProps.isAudioEnabled };
        }
        return (dispatchProps.redialCall(
          stateProps.callDialString,
          stateProps.isWebConferencing,
          stateProps.isJoinFlowCall,
          media
        ));
      },
      clearCall: () => (dispatchProps.clearCall(stateProps.isGuest))
    }
  )
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DroppedCallModal);
